import ApplicantErrors from "./ApplicantErrors.component";

export default ApplicantErrors;